export const HULL_BASE_SPEED: Record<string, number> = {
  corvette: 100,
  frigate: 75,
  destroyer: 55,
  scout_drone: 160,
  transport_ship: 60,
};

export function calculateDistance(x1: number, y1: number, x2: number, y2: number): number {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const dist = Math.sqrt(dx * dx + dy * dy);
  return Math.max(1, Math.round(dist * 10) / 10);
}

export function calculateFleetSpeed(hullIds: string[]): number {
  if (hullIds.length === 0) return 100;
  let minSpeed = 999;
  for (const h of hullIds) {
    const spd = HULL_BASE_SPEED[h] ?? 75;
    if (spd < minSpeed) minSpeed = spd;
  }
  return minSpeed;
}

export function calculateMarchTimeSec(distance: number, speed: number): number {
  // Balanced for Telegram mini-app: ~15s to 120s typical flights
  const seconds = Math.round((distance * 35) / Math.max(20, speed));
  return Math.max(5, Math.min(300, seconds));
}

export function calculateFuelCost(distance: number, totalShips: number): number {
  const cost = Math.round(distance * Math.max(1, totalShips) * 0.4);
  return Math.max(10, cost);
}
